import { useContext, useState } from 'react';
import { Link, CardContent, Card, Typography, CardHeader, Avatar, Tooltip, Grid, Table, TableHead, TableRow, TableBody, TableCell } from '@material-ui/core';
import moment from 'moment';
import { ticketContext } from '../../TicketContext';
import { MessageStatus, EditIconButton, MediaThumb, FileIcon, DeleteIconButton } from 'components';
import { Form, Formik } from 'formik';
import MessageEditor from './MessageEditor';
import { IMessage, messageContext, messageSchema } from './MessagesContext';
import Moment from 'react-moment';
import { appUserContext } from 'helpers/services';
import { UserType } from 'helpers/enums';


interface IProps {
    message: IMessage
}

let Message = ({ message }: IProps) => {
    let { currentUser } = useContext(appUserContext);
    let { ticket } = useContext(ticketContext);
    let { isValidMessage, saveMessage, deleteMessage } = useContext(messageContext);

    let [currentMessageId, setCurrentMessageId] = useState<string | null>(null);


    return (
        <Card>
            <CardHeader
                avatar={(
                    <Avatar alt={message.createdBy}>
                        {message.createdBy?.charAt(0).toUpperCase()}
                    </Avatar>
                )}
                title={<>{message.createdBy}{message.createdByCompany && <>&nbsp;&middot;&nbsp;{message.createdByCompany}&nbsp;</>}</>}
                subheader={(
                    <Tooltip title={`${moment(message.createdOn).format("LLL")}`} placement="bottom-start">
                        <span>{moment(message.createdOn).fromNow()}</span>
                    </Tooltip>
                )}
                action={currentUser?.typology === UserType.VitecUser ? <MessageStatus isPublic={message.isPublic} isFromCustomer={message.isFromCustomer} /> : ''}
            />
            <CardContent>
                {currentMessageId !== message.messageId &&
                    <>
                        <Grid container alignItems="center">
                            <Grid item xs>
                                <Typography dangerouslySetInnerHTML={{ __html: message.text }} />
                            </Grid>

                            {(message.canEdit || message.canDelete) &&
                                <Grid item>
                                    {message.canEdit &&
                                        <EditIconButton onClick={() => setCurrentMessageId(message.messageId)} />
                                    }

                                    {message.canDelete &&
                                        <DeleteIconButton onClick={() => deleteMessage(message.messageId)} />
                                    }
                                </Grid>
                            }
                        </Grid>
                        {message.attachments.length > 0 &&
                            <Grid container>
                                {message.attachments.filter(x => x.isImage === false).length > 0 &&
                                    <Grid item xs={12}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Uploaded from</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {message.attachments
                                                    .filter(x => x.isImage === false)
                                                    .map((file, index) =>
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                <Link href={file.downloadUrl}>
                                                                    <FileIcon extension={file.extension} />&nbsp;{file.fileName}
                                                                </Link>
                                                            </TableCell>
                                                            <TableCell>
                                                                {file.createdBy}&nbsp;{file.createdByCompany && <>&nbsp;&middot;&nbsp;{file.createdByCompany}&nbsp;</>}on&nbsp;<Moment date={file.createdOn} format="LL" />
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                            </TableBody>
                                        </Table>
                                    </Grid>
                                }
                                {message.attachments
                                    .filter(x => x.isImage === true)
                                    .map(file =>
                                        <Grid item key={file.fileId}>
                                            <MediaThumb
                                                extension={file.extension}
                                                height={150}
                                                width={150}
                                                fileId={file.fileId}
                                                isImage={file.isImage}
                                                fileIds={
                                                    [...message.attachments]
                                                    .filter(x => x.isImage === true)
                                                    .map(file => file.fileId)
                                                }            
                                            />
                                            <Link href={file.downloadUrl}>Download</Link>
                                        </Grid>
                                    )
                                }
                            </Grid>
                        }
                    </>
                }

                {currentMessageId === message.messageId &&
                    <Grid container>
                        <Grid item xs={12}>
                            <Formik
                                enableReinitialize={true}
                                validationSchema={messageSchema}
                                initialValues={messageSchema.getDefault()}
                                onSubmit={async (values, actions) => {
                                    if (isValidMessage(values.text) === false)
                                        actions.setFieldError("text", 'You must provide valid message');
                                    else {
                                        await saveMessage(values);
                                        setCurrentMessageId(null);
                                    }
                                }}
                            >
                                <Form>
                                    <MessageEditor
                                        ticketId={ticket.id}
                                        editMessage={message}
                                        onClose={() => setCurrentMessageId(null)}
                                    />
                                </Form>
                            </Formik>
                        </Grid>
                    </Grid>
                }
            </CardContent>
        </Card >
    )
}

export default Message;